import { Component, OnInit } from '@angular/core';
import {JourneyService} from "../../Services/journey.service";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
declare var $;
@Component({
  selector: 'app-batch-links',
  templateUrl: './batch-links.component.html',
  styleUrls: ['./batch-links.component.css'],
  providers: [JourneyService]
})
export class BatchLinksComponent implements OnInit {

  orientation: any;
  screenWidth: number = 1366;
  screenHeight: number;
  userID;
  communityID;
  batchLinkListData: any;
  popupWindow = null;

  constructor(private journeyService: JourneyService, private translate: TranslateService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    $("#preloader").css('display', 'block');
    let lang_name = localStorage.getItem('defaultLang');
    this.translate.use(lang_name);
    $(document).ready(function () {
      $("#disablePrevent").on("contextmenu", function () {
        return false;
      });
    });
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    this.orientation = window.orientation;
    this.screenWidth = screen.width || window.screen.width;
    console.log(this.screenWidth);

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
      } else {
        this.screenWidth = screen.width || window.screen.width;
      }
    });
    localStorage.setItem('currentScreen', 'JOURNEY_DETAILS');
    this.journeyService.refreshToken();

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userID = currentUser.user.userid;
    this.communityID = currentUser.user.community_id;
    if (this.userID) {
      let lang_id = localStorage.getItem('defaultLangId') ? localStorage.getItem('defaultLangId') : 'English';
      let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
      /*let dObj = {
        link_id: link_id,
        user_name: this.userID,
        community_id: this.communityID
      };*/

      this.journeyService.batchLinkContent(lang_id).subscribe(btResult => {
        if(btResult.success){
          this.batchLinkListData = btResult.data;
          $('#batchLinksModal').modal('show');
          $("#preloader").css('display', 'none');
        }else{
          this.batchLinkListData = null;
          $('#batchLinksModal').modal('show');
          $("#preloader").css('display', 'none');
        }
      });

    } else {
      $("#preloader").css('display', 'none');
      this.router.navigate(['/login']);
    }
  }

  visitBatchLink(url){
    this.popupWindow = window.open(url, '_self');
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/batch-links/batch-links.component.ts